import actionTypes from '../actions/actionTypes';

export const INITIAL_STATE = {
  loading: false,
  error: false,
  foundReservations: {
    totalHits: null,
    reservations: [],
  },
};

export const reservationsGlobalSearch = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case actionTypes.RESERVATIONS_ADVANCED_SEARCH_LOADING:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.RESERVATIONS_ADVANCED_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        foundReservations: {
          totalHits: payload.totalHits,
          reservations: [...state.foundReservations.reservations, ...payload.reservations],
        },
      };
    case actionTypes.RESERVATIONS_ADVANCED_SEARCH_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.RESET_ADVANCED_SEARCH_RESERVATIONS:
      return {
        ...INITIAL_STATE,
      };
    default:
      return state;
  }
};

export default reservationsGlobalSearch;
